// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__2NsGJ","message_h3":"message_message_h3__oq0Bw","message_p":"message_message_p__3CYmC"};